import { HeroSeoCotizador } from "../Landings/Components/HeroSeoCotizador";
import { PorQueElegirnos } from "../Landings/Components/PorQueElegirnos";
import { ComoFuncionaElCotizador } from "../Landings/Components/ComoFuncionaElCotizador";
import { QueCubreEsteSeguro } from "../Landings/Components/QueCubreEsteSeguro";
import { CompaniasSlider } from "../Landings/Components/CompaniasSlider";
import { PreguntasFrecuentes } from "../Landings/Components/PreguntasFrecuentes";
import { CtaCierreCotizador } from "../Landings/Components/CtaCierreCotizador";
import { imagesCompanias } from "../../Assets/imageCompaniasMoto";
import heroSeoMoto from "../../Assets/img/heroSeoMoto.png";
import "../Landings/Components/seoCotizador.css";

interface Props {
    visible: boolean;
}

const ASEGURADORAS_MOTO_AR = [
    "Mapfre",
    "Integrity Seguros",
    "Libra Seguros",
    "San Cristóbal Seguros",
    "Allianz",
    "Sancor Seguros",
];

const listaAseguradoras = () => new Intl.ListFormat("es", { style: "long", type: "conjunction" }).format(ASEGURADORAS_MOTO_AR);

const companiasParaSlider = imagesCompanias.filter(
    (compania) => compania.pais?.includes("AR")
);

const scrollAlCotizador = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
};

export const SeoContenido = ({ visible }: Props) => {
    if (!visible) {
        return null;
    }

    return (
        <div className="seo-cotizador-scope">
            <HeroSeoCotizador
                h1="Cotizador de seguro de moto online: Compará y contratá en minutos"
                bajada="Cotizá el seguro de tu moto en minutos y compará entre las principales aseguradoras del país para andar protegido sin pagar de más."
                parrafos={[
                    "El seguro de moto es obligatorio en Argentina y, además de cumplir con la ley, es la mejor forma de protegerte a vos y a terceros ante un siniestro. Con el cotizador de seguro de moto de Segurarse podés comparar en simultáneo precios y coberturas de distintas aseguradoras, sin moverte de tu casa y sin costo.",
                    "Las motos son uno de los vehículos con mayor siniestralidad vial, por eso el precio del seguro varía mucho según la cilindrada, el modelo, la zona de circulación y el uso (particular, delivery o trabajo). Nuestro comparador tiene en cuenta estas variables para mostrarte cotizaciones ajustadas a tu situación real, desde Responsabilidad Civil hasta coberturas contra robo e incendio.",
                    "Si usás la moto para trabajar en apps de delivery o como medio de transporte diario, contamos con opciones de cobertura pensadas para ese uso intensivo. Elegí la opción que más te convenga y contratá tu seguro al instante, sin trámites adicionales.",
                ]}
                ctaTexto="Cotizar mi seguro ahora"
                onCtaClick={scrollAlCotizador}
                imagenSrc={heroSeoMoto}
            />
            <PorQueElegirnos
                titulo="Por qué cotizar acá"
                bullets={[
                    "Cotizás online y gratis, sin compromiso de contratación.",
                    "Comparás precios y coberturas de las aseguradoras líderes del mercado argentino en una sola búsqueda.",
                    "Elegís entre opciones para uso particular, delivery y trabajo.",
                    "Contás con asesoramiento de especialistas para elegir la cobertura según tu cilindrada y uso.",
                    "Gestionás tus pólizas y siniestros online, las 24 horas, desde Mi Segurarse.",
                ]}
                mostrarImagen={false}
                anchoCompleto={true}
            />
            <ComoFuncionaElCotizador
                pasos={[
                    { numero: "1", texto: "Ingresá la marca, modelo y año de tu moto." },
                    { numero: "2", texto: "Indicá tus datos personales." },
                    { numero: "3", texto: "En minutos comparás las cotizaciones disponibles y elegís la cobertura que mejor se adapta a vos." },
                ]}
            />
            <QueCubreEsteSeguro
                texto="Las coberturas más comunes para motos van desde la Responsabilidad Civil obligatoria hasta paquetes que incluyen robo total, incendio, destrucción total por accidente y asistencia mecánica. Cuanto mayor es la cilindrada o el valor de la moto, más conviene evaluar coberturas intermedias que cubran el robo, uno de los siniestros más frecuentes en este segmento."
            />
            <div className="seo-cotizador-section">
                <div className="container">
                    <h2 className="seo-cotizador-h2">
                        Aseguradoras
                    </h2>
                    <p className="seo-cotizador-texto-bloque">
                        {`Cotizamos con aseguradoras especializadas en el segmento moto y con las principales compañías generales del mercado argentino: ${listaAseguradoras()}, para que tengas opciones tanto para motos urbanas como para uso intensivo de trabajo.`}
                    </p>
                    <CompaniasSlider companias={companiasParaSlider} />
                </div>
            </div>
            <PreguntasFrecuentes
                tituloClassName="seo-cotizador-h2"
                faqs={[
                    {
                        titulo: "¿Cómo funciona el cotizador de seguros para motos?",
                        subTitulo: "Indicá la marca, modelo, año de tu moto y el uso que le das. En minutos comparás las cotizaciones disponibles para elegir la cobertura que mejor se adapta a vos.",
                    },
                    {
                        titulo: "¿Es gratis cotizar un seguro de moto?",
                        subTitulo: "Sí, cotizar no tiene costo ni obligación de contratar.",
                    },
                    {
                        titulo: "¿Qué información necesito para cotizar?",
                        subTitulo: "Marca, modelo, año y el uso que le das a la moto (particular, delivery o trabajo).",
                    },
                    {
                        titulo: "¿Cuánto tarda una cotización?",
                        subTitulo: "Con los datos básicos de tu moto obtenés las cotizaciones en minutos, de forma online.",
                    },
                    {
                        titulo: "¿Qué compañías participan en el cotizador?",
                        subTitulo: `Cotizamos con aseguradoras especializadas en el segmento moto y con las principales compañías generales del mercado argentino: ${listaAseguradoras()}.`,
                    },
                    {
                        titulo: "¿Puedo comparar precios entre distintas aseguradoras?",
                        subTitulo: "Sí, comparás precios y coberturas de las aseguradoras líderes del mercado en una sola búsqueda.",
                    },
                    {
                        titulo: "¿Qué tipos de cobertura puedo cotizar?",
                        subTitulo: "Desde Responsabilidad Civil obligatoria hasta paquetes con robo total, incendio y asistencia mecánica.",
                    },
                    {
                        titulo: "¿Puedo contratar el seguro completamente online?",
                        subTitulo: "Sí, una vez que elegís la cobertura podés emitir la póliza online y recibirla por email en minutos.",
                    },
                    {
                        titulo: "¿Por qué usar el cotizador de Segurarse?",
                        subTitulo: "Es 100% online y gratuito, compara aseguradoras líderes en tiempo real, incluye asesoramiento humano post-cotización y te permite emitir la póliza y gestionar siniestros sin trámites presenciales.",
                    },
                ]}
            />
            <CtaCierreCotizador
                texto="Cotizá el seguro de tu moto ahora y encontrá el precio más conveniente."
                onClick={scrollAlCotizador}
            />
        </div>
    );
};
